/** The one error every AI text ends in when the AI could not write it. Template text is never passed off as the AI's. */
import { Button } from '../../../components/ui/button';
import { cn } from '../../../lib/utils';
import type { AiFailure } from './aiFailure';

export interface AiFailureNoticeProps {
  failure: AiFailure;
  onRetry?: () => void;
  onTemplate?: () => void;
  busy?: boolean;
  /** What failed, for the buttons' accessible names ("follow-up", "draft for @name"). */
  label?: string;
  className?: string;
  /** status inside lists, so a screen reader does not announce one alert per row. */
  role?: 'alert' | 'status';
}

export function AiFailureNotice({ failure, onRetry, onTemplate, busy = false, label, className, role = 'alert' }: AiFailureNoticeProps) {
  const suffix = label ? ` ${label}` : '';
  return (
    <div role={role} data-testid="ai-failure" className={cn('flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-destructive', className)}>
      <span>{failure.message}</span>
      {failure.reason ? <code className="font-mono text-[11px] text-muted-foreground">{failure.reason}</code> : null}
      {onRetry && failure.retryable ? (
        <Button type="button" size="sm" variant="outline" className="h-6 px-2 text-xs" disabled={busy} aria-label={`Retry${suffix}`} onClick={onRetry}>
          Retry
        </Button>
      ) : null}
      {onTemplate ? (
        <Button
          type="button"
          size="sm"
          variant="outline"
          className="h-6 px-2 text-xs"
          disabled={busy}
          aria-label={`Template${suffix}`}
          title="Use the template text. The assistant did not write it."
          onClick={onTemplate}
        >
          Template
        </Button>
      ) : null}
    </div>
  );
}
